import React, { useRef, useEffect, useState } from 'react'
import classnames from 'classnames'
import ArrowForward from '../../assets/img/arrow-forward.png'
import BagIcon from '../../assets/img/bag.png'
import './Bag.css'
import { useOnScreen, useHover, usePrevious } from '../../utils/hooks'

const Bag = props => {
  const { className, style, onClick, count, lastItemInOrder } = props

  const prevCount = usePrevious(count)

  const bagRef = useRef(null)
  const bagIsOnScreen = useOnScreen(bagRef)
  const bagIsHovered = useHover(bagRef)

  const [showBagTooltip, setShowBagTooltip] = useState()

  useEffect(() => {
    if (typeof prevCount !== 'undefined' && count) {
      setShowBagTooltip(true)

      const timer = setTimeout(() => {
        setShowBagTooltip(false)
      }, 2000)

      return () => {
        clearTimeout(timer)
      }
    }
  }, [count, bagIsHovered])

  const _onClick_ = () => {
    onClick()
    setShowBagTooltip(false)
  }

  return (
    <div
      className={classnames('cookunity__bag_container', className)}
      style={style}>
      <img
        onClick={_onClick_}
        ref={bagRef}
        className="bag"
        src={BagIcon}
        alt="bag icon"
      />

      {!!count && (
        <div className="count">
          <span>{count}</span>
        </div>
      )}

      {!!count && (
        <div
          className={classnames('bag_tooltip_container', {
            absolute: bagIsOnScreen,
            fadeIn: showBagTooltip
          })}>
          <div className="arrow" />
          <div className="bag_tooltip" onClick={_onClick_}>
            {lastItemInOrder && (
              <div
                alt="meal"
                className="meal_pic"
                style={{ backgroundImage: `url(${lastItemInOrder.mealImage})` }}
              />
            )}
            <div className="content">
              <p className="count">{count} items in your cart</p>
              <p className="review">Review and checkout</p>
            </div>
            <img
              src={ArrowForward}
              alt="arrow forward"
              className="arrow_forward"
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default Bag



// WEBPACK FOOTER //
// ./src/components/Bag/Bag.jsx